const initialState = {
  rules: [],
  labels: [],
  addressees: [],
  isLoading: false,
  error: false,
  errorMessage: '',
};

// Redux reducer contract: (state, action) with state defaulted.
// eslint-disable-next-line default-param-last
export default (state = initialState, action) => {
  switch (action.type) {
    case 'BEGIN_GET_TEAM_ROUTING_RULES':
      return {
        ...state,
        isLoading: true,
        error: false,
        errorMessage: '',
      };
    case 'FINISH_GET_TEAM_ROUTING_RULES':
      return {
        ...state,
        isLoading: false,
        rules: action.payload.data.team_routing_rules || [],
      };
    case 'FAILED_GET_TEAM_ROUTING_RULES':
      return {
        ...state,
        isLoading: false,
        error: true,
        errorMessage: action.payload?.response?.data?.error || 'Failed to load routing rules',
      };
    case 'BEGIN_CREATE_TEAM_ROUTING_RULE':
      return {
        ...state,
        isLoading: true,
        error: false,
        errorMessage: '',
      };
    case 'FINISH_CREATE_TEAM_ROUTING_RULE':
      return {
        ...state,
        isLoading: false,
        rules: [...state.rules, action.payload.data.team_routing_rule],
      };
    case 'FAILED_CREATE_TEAM_ROUTING_RULE':
      return {
        ...state,
        isLoading: false,
        error: true,
        errorMessage: action.payload?.response?.data?.error || 'Failed to create routing rule',
      };
    case 'BEGIN_UPDATE_TEAM_ROUTING_RULE':
      return {
        ...state,
        isLoading: true,
        error: false,
        errorMessage: '',
      };
    case 'FINISH_UPDATE_TEAM_ROUTING_RULE': {
      const updatedRule = action.payload.data.team_routing_rule;
      return {
        ...state,
        isLoading: false,
        rules: state.rules.map((rule) => (rule.id === updatedRule.id ? updatedRule : rule)),
      };
    }
    case 'FAILED_UPDATE_TEAM_ROUTING_RULE':
      return {
        ...state,
        isLoading: false,
        error: true,
        errorMessage: action.payload?.response?.data?.error || 'Failed to update routing rule',
      };
    case 'BEGIN_DELETE_TEAM_ROUTING_RULE':
      return {
        ...state,
        isLoading: true,
        error: false,
        errorMessage: '',
      };
    case 'FINISH_DELETE_TEAM_ROUTING_RULE':
      return {
        ...state,
        isLoading: false,
        // The component refetches the rules list after a successful delete
        // (the DELETE response carries no body to reduce from).
      };
    case 'FAILED_DELETE_TEAM_ROUTING_RULE':
      return {
        ...state,
        isLoading: false,
        error: true,
        errorMessage: action.payload?.response?.data?.error || 'Failed to delete routing rule',
      };
    case 'BEGIN_REORDER_TEAM_ROUTING_RULES':
      return {
        ...state,
        isLoading: true,
        error: false,
        errorMessage: '',
      };
    case 'FINISH_REORDER_TEAM_ROUTING_RULES':
      return {
        ...state,
        isLoading: false,
      };
    case 'FAILED_REORDER_TEAM_ROUTING_RULES':
      return {
        ...state,
        isLoading: false,
        error: true,
        errorMessage: action.payload?.response?.data?.error || 'Failed to reorder routing rules',
      };
    case 'FINISH_GET_TEAM_ROUTING_RULE_LABELS':
      return {
        ...state,
        labels: action.payload.data.labels || [],
      };
    case 'FINISH_GET_TEAM_ROUTING_RULE_ADDRESSEES':
      return {
        ...state,
        // An empty contacts search returns a message payload with no recipients key.
        addressees: action.payload.data.recipients || [],
      };
    default:
      return state;
  }
};
